
import { ChangeDetectionStrategy, Component, OnInit, input, output } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ErrorMsgComponent } from '@fitness-force/errors';;
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'change-billling-name',
  templateUrl: './change-billling-name.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    DialogModule,
    ReactiveFormsModule,
    ButtonModule,
    InputTextModule,
    ErrorMsgComponent,
    TranslateModule
]
})
export class ChangeBilllingNameComponent implements OnInit {
  readonly showModel = input(false, { alias: "visible" });
  readonly removeBillingname = input(false, { alias: "removeName" });
  readonly closeChangeBillingNameDialogEvent = output<{
    hidePopup: boolean;
    billingName: string;
}>();

  billingNameForm: UntypedFormGroup = new UntypedFormGroup({ billing_name: new UntypedFormControl('', [Validators.required, Validators.minLength(1)]) });

  constructor() { }

  ngOnInit(): void {
    if(this.removeBillingname())
    {
      this.removeBillingName();
    }
  }

  get billingNameFormControl(): UntypedFormControl {
    return this.billingNameForm.controls.billing_name as UntypedFormControl;
  }

  removeBillingName() {
    this.billingNameFormControl.setValue('');
  }

  ClosePopup()
  {
    this.closeChangeBillingNameDialogEvent.emit({hidePopup:true, billingName:this.billingNameFormControl.value});
  }

  closeModel()
  {
    this.ClosePopup();
  }

}
